import { render } from "./index.vue?vue&type=template&id=2340f9c4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2340f9c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_c888307087c990cfda5c0d18ef320e2e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2340f9c4"],['__file',"src/components/scUpload/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2340f9c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2340f9c4', __exports__)) {
    api.reload('2340f9c4', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2340f9c4&scoped=true", () => {
    api.rerender('2340f9c4', render)
  })

}


export default __exports__